import React, { Fragment, useState } from "react";
import PropTypes from "prop-types";
import { CDropDown } from "@appcues/component-library";
import { getFontNameFromGoogleUrl } from "fonts";

import ThemeFontDropdownOption from "./ThemeFontDropdownOption";
import AddFontModal from "./AddFontModal";
import EditTypekitIdModal from "./EditTypekitIdModal";

export const ThemeFontDropdown = ({
  value = "",
  defaultOptions = [],
  customFontUrls = [],
  typekitId,
  onChange,
  onAddGoogleFont,
  onChangeTypekitId,
  onDelete
}) => {
  const [currentModal, setCurrentModal] = useState(null);

  const handleAddFont = () => setCurrentModal("addGoogleFont");
  const handleEditTypekitId = () => setCurrentModal("editTypekitId");
  const handleCloseModal = () => setCurrentModal(null);

  const options = [
    {
      label: "Adobe fonts",
      options: [
        typekitId
          ? { label: typekitId, value: typekitId, type: "adobe" }
          : { label: "Add Adobe Font", type: "addAdobeFont", disabled: true }
      ]
    },
    {
      label: "Google fonts",
      options: [
        ...customFontUrls.map(url => ({
          label: getFontNameFromGoogleUrl(url),
          value: getFontNameFromGoogleUrl(url),
          type: "google",
          url
        })),
        // dummy option that will be rendered as an "Add font" button
        { type: "addGoogleFont", disabled: true }
      ]
    },
    { label: "Default fonts", options: defaultOptions }
  ];

  return (
    <Fragment>
      {currentModal === "addGoogleFont" && (
        <AddFontModal onSubmit={onAddGoogleFont} onClose={handleCloseModal} />
      )}
      {currentModal === "editTypekitId" && (
        <EditTypekitIdModal
          value={typekitId}
          onSubmit={onChangeTypekitId}
          onClose={handleCloseModal}
        />
      )}
      <CDropDown
        components={{
          // define a custom Option renderer so we can inject the "Delete custom
          // font" and "Add custom font" options directly into the CDropDown
          // as per the design
          Option: ThemeFontDropdownOption
        }}
        placeholder="Select a font"
        value={value}
        defaultValue={defaultOptions[0]}
        onChange={onChange}
        onAddFont={handleAddFont}
        onEditTypekitId={handleEditTypekitId}
        onDelete={onDelete}
        options={options}
        usePortal
        marginRight={24}
        minWidth={168}
      />
    </Fragment>
  );
};

ThemeFontDropdown.propTypes = {
  value: PropTypes.string,
  defaultOptions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string
    })
  ),
  customFontUrls: PropTypes.arrayOf(PropTypes.string),
  typekitId: PropTypes.string,
  onChange: PropTypes.func,
  onAddGoogleFont: PropTypes.func,
  onChangeTypekitId: PropTypes.func,
  onDelete: PropTypes.func
};

export default ThemeFontDropdown;
